<template>
  <div class="menu-tabs sm:border-0 sm:bg-white radius-3">
    <a
      v-for="(item, index) in navigations"
      :key="`menu-tab-item-${index}`"
      :class="[
        'tab-item',
        item.class,
        { active: item.routes.includes(activeTab) },
        { 'border-first': item.first },
        { 'border-last': item.last }
      ]"
      @click="goto(item)"
    >
      <span class="mobile-icon"></span>
      <span class="lg:hidden font-bold">{{ item.labelDesktop }}</span>
      <span class="hidden lg:block font-bold">{{ item.labelMobile }}</span>
    </a>
  </div>
</template>

<script>
import _ from 'lodash'

export default {
  props: ['data', 'isRakutenFlg'],
  data() {
    return {
      menuNavigations: [
        {
          icon: 'icon-bor-information',
          class:'info-tab',
          labelDesktop: '基本情報',
          labelMobile: '基本情報',
          active: true,
          routes: ['/menus/:menuNo'],
        },
        {
          icon: 'icon-bor-plan',
          class: 'plan-list-tab',
          labelDesktop: 'プラン',
          labelMobile: 'プラン',
          active: false,
          routes: ['/menus/:menuNo/plans', '/menus/:menuNo/plans/:planId/rooms/:roomId'],
        },
        // {
        //   icon: 'icon-bor-plan',
        //   labelDesktop: 'プラン',
        //   labelMobile: 'プラン',
        //   active: false,
        //   routes: ['/menus/:menuNo/plans/:planId/rooms/:roomId'],
        //   query: this.$route.query
        // },
        {
          icon: 'icon-bor-img',
          class: 'gallery-tab',
          labelDesktop: 'フォト',
          labelMobile: 'フォト',
          active: false,
          routes: ['/menus/:menuNo/photo-gallery'],
        }
        // {
        //   icon: 'icon-bor-bubble',
        //   labelDesktop: 'クチコミ',
        //   labelMobile: 'クチコミ',
        //   active: false,
        //   routes: ['/menus/:menuNo/reviews'],
        //   query: this.$route.query
        // }
      ],
      // queryは共通のため、参照・更新しやすいように外に出す
      query: this.$route.query,
    }
  },
  mounted() {
    if (this.data) {
      this.menuNavigations = _.cloneDeep(this.data)
    }
  },
  computed: {
    activeTab() {
      return this.$route.path
    },
    navigations() {
      const params = this.$route.params
      const menuNavigaions = _.cloneDeep(this.menuNavigations)
      // 楽天の場合は、フォトギャラリーを非表示にする(初回リリース時対応)
      if (this.isRakutenFlg) {
        // 末尾の要素(フォトギャラリー)を削除
        menuNavigaions.pop();
      }
      return menuNavigaions.map((m) => {
        m.routes = this.formatRoutePattern(m.routes, params)
        return m
      })
    }
  },
  //queryの変更をタブに反映させる
  watch: {
    '$route.query': {
      handler(newQuery){
        console.log("newQuery:", newQuery);
        if (newQuery){
          this.query = newQuery;
        }
      }
    }
  },
  methods: {
    formatRoutePattern(routes) {
      const { menuNo, planId, roomId } = this.$route.params
      return routes.map((route) => {
        let formatedPath = String(route)
        if (formatedPath.indexOf(':menuNo') >= 0) {
          formatedPath = formatedPath.replace(':menuNo', menuNo)
        }
        if (formatedPath.indexOf(':planId') >= 0) {
          formatedPath = formatedPath.replace(':planId', planId)
        }
        if (formatedPath.indexOf(':roomId') >= 0) {
          formatedPath = formatedPath.replace(':roomId', roomId)
        }
        return formatedPath
      })
    },
    goto(nav) {
      if (nav.routes.length) {
        // 更新されたqueryを使って画面遷移
        this.$router.push({ path: this.formatRoutePattern(nav.routes)[0], query: this.query })
      } else if (nav.href) {
        if (nav._bank) {
          window.open(nav.href)
        } else {
          location.href(nav.href)
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import './styles.scss';
</style>
